import React from "react"

const Longform = ({ children, className = "" }) => {
  return <article className={`longform ${className}`}>{children}</article>
}

export default Longform
